import JsBarcode from "jsbarcode";

export const createBarcode = (data: string) => {
  const canvas = document.createElement("canvas");
  JsBarcode(canvas, data, { fontSize: 16, textMargin: 4 });
  return canvas.toDataURL();
};
